import { render, staticRenderFns } from "./ListStructure.vue?vue&type=template&id=40a631d4&scoped=true"
import script from "./ListStructure.vue?vue&type=script&lang=ts"
export * from "./ListStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a631d4",
  null
  
)

export default component.exports